angular.module('wbDashboard').controller('PlanningHavenControllerAurea', ['$scope', '$timeout', '$uibModal', '$q', 'PlanningService', 'ThinkingService', 'CommonConstant', 'Message', 'Request', 'Track', function ($scope, $timeout, $uibModal, $q, PlanningService, ThinkingService, CommonConstant, Message, Request, Track) {
    if ($scope.$stateParams.page === "mobile") {
        $scope.haven = {
            coverageAmount: $scope.$stateParams.coverageAmount,
            termLength: $scope.$stateParams.termLength,
            source: $scope.$stateParams.source,
            token: $scope.$stateParams.token,
            monthlyRate: $scope.$stateParams.monthlyRate,
        };
        $timeout(function() {
            angular.element("form[name='forms.haven']").submit();
        }, 100);
    } else {
        if ($scope.$stateParams.page !== "introducing" && !$scope.haven) {
            $scope.$state.go(".", {page: "introducing"}, {location: "replace"});
        }
        $scope.haven = {
            source : null,
            token: null,
            url: CommonConstant.haven.url,
            coverageAmount: null,
            termLength: null,
            termIndex: null,
            monthlyRate: null,
            timer: null,
            recommendations: {}
        };
    }

    $scope.haven.url = CommonConstant.haven.url;

    $scope.pageData = {
        sending: false,
        updatingQuote: false,
        showTerm: false,
        thinking: true,
        modalInstance: null,
    };
    $scope.forms = {};

    $scope.options = {
        terms: [10, 15, 20, 30]
    };

    $scope.recommendationSlug = $scope.$stateParams.recommendationSlug ? $scope.$stateParams.recommendationSlug : PlanningService.partnerInfo.haven.slug;


    $scope.showLoading = function() {

        ThinkingService.open($scope, 'haven');

    };

    $scope.havenModal = function() {
        $scope.pageData.modalInstance = $uibModal.open({
            templateUrl: 'modal-planning-haven-info.tpl.html',
            scope: $scope,
            size: 'md',
            windowClass:'haven-info-modal partner-info-modal confirm-modal'
        });
        $scope.pageData.modalInstance.result.catch(angular.noop);
    };

    $scope.submitToHaven = function() {

        Track.send("Send to Partner", "planning", {partner: "haven"});

        PlanningService.completeRecommendation($scope.recommendationSlug).then(function() {
            angular.element("form[name='forms.haven']").submit();
        });
    };

    $scope.showTerm = function() {
        Track.send("Page Viewed", "planning", {page: "Haven Edit Term View"});
        $scope.pageData.showTerm = true;
    };

    if ($scope.$stateParams.page !== "mobile") {
        init();
    }

    function init() {
        $scope.$watch('haven.termIndex', function (index) {
            $scope.haven.termLength = $scope.options.terms[index - 1];
        });

        $scope.$watchGroup(['haven.coverageAmount', 'haven.termLength'], function (values) {
            var amount = values[0];
            var length = values[1];
            $timeout.cancel($scope.haven.timer);
            if (!amount && !length) {
                updateQuote();
                $scope.haven.timer = $timeout(function () {}); //needs to be set
            } else if (amount === $scope.haven.recommendations.coverageAmount && length === $scope.haven.recommendations.termLength) {
                //prevent the second request after default recommendations are set but it's marked as changed
                $scope.haven.monthlyRate = $scope.haven.recommendations.monthlyRate;
                $scope.pageData.updatingQuote = false;
            } else {
                $scope.pageData.updatingQuote = true;
                //when updated after survey
                $scope.haven.timer = $timeout(function () {
                    //need to create manual debounce
                    updateQuote(amount, length);
                }, 750);
            }
        });

        $scope.showLoading();

    }

    function getToken() {
        if ($scope.pageData.sending || $scope.pageData.updatingQuote) {
            return $q.reject(0);
        }

        var data = {
            coverageAmount: $scope.haven.coverageAmount,
            termLength: $scope.haven.termLength,
            policyPrice: $scope.haven.monthlyRate
        };
        $scope.pageData.sending = true;
        return Request.make('haven_jwt', data).then(function(response) {
            $scope.haven.source = response.data.response.source;
            $scope.haven.token = response.data.response.token;
        }).catch(function(response) {
            console.log(response);
            Message.set({
                text:"Couldn't get haven token at this time",
                type: "warning"
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    }

    function updateQuote(amount, length) {
        $scope.pageData.sending = true;
        $scope.pageData.updatingQuote = true;

        $scope.haven.monthlyRate = null;
        return Request.make('haven_quote', {coverageAmount: amount, termLength: length}).then(function(response) {
            var quote = response.data.response;

            if ($scope.haven.coverageAmount === amount && $scope.haven.termLength === length) {
                //in case it was changed since requested
                $scope.haven.monthlyRate = quote.monthly_rate;
            }

            if (!$scope.haven.coverageAmount && !$scope.haven.termIndex) {
                //initial call
                $scope.haven.recommendations = quote.recommendations;
                $scope.haven.recommendations.monthlyRate = quote.monthly_rate;
                $scope.haven.coverageAmount = quote.recommendations.coverageAmount;
                $scope.haven.termIndex = $scope.options.terms.indexOf(quote.recommendations.termLength) + 1;
            }

        }).catch(function(err) {
            if ("data" in err && err.data.errors) {
                Message.set({
                    text: err.data.errors.join(".\n  "),
                    type: "warning"
                });
            }
            if (!$scope.$state.transition) {
                //in case it fails consecutive times, don't want to redirect again
                $scope.$state.go("base.planning.survey", {sId: "164483"}, {location: "replace"});
            }
        }).finally(function() {

            if ($scope.pageData.thinking) {
                $timeout(function () {
                    $scope.pageData.thinking = false;
                    ThinkingService.close(false, 'haven');
                }, 1000);
            }

            $scope.pageData.sending = false;
            $scope.pageData.updatingQuote = false;
        });

    }


    var transitionDeregisterHook;
    transitionDeregisterHook = $scope.$transitions.onBefore({ to: 'base.planning.haven' }, function(trans) {
        if (trans.params('to').page === "submit") {
            return getToken();
        }
    });
    $scope.$on('$destroy', function() {
        transitionDeregisterHook();
    });

}]);
